module.exports = __webpack_public_path__ + "img/category-favorite-hover.23bbf7d4.png";